import React, { useMemo, useState } from "react";
import AdminTabelHeader from "../../components/layout/header/AdminTabelHeader";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import useGetData from "../../../hooks/apihooks/useGetData";
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../utils/BaseUrl";
import Swal from "sweetalert2";
import { LuGalleryVerticalEnd } from "react-icons/lu";
import TraingleLoading from "../../../common/Loading/TraingleLoading";

const AdminImageGallery = () => {
  const navigate = useNavigate();
  const { data, isLoading, isError } = useGetData(
    "galleries",
    "getAllimagegalleries"
  );

  const queryClient = useQueryClient();
  const deltemutaion = useMutation({
    mutationFn: (id) => {
      return axios.delete(`${BASEURL}gallery/${id}`);
    },
    onSuccess: () => {
      Swal.fire({
        title: "Deleted Successfully",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button",
        },
      });
      queryClient.invalidateQueries({ queryKey: "getAllimagegalleries" });
    },
  });

  const allDeltemutaion = useMutation({
    mutationFn: (name) => {
      return axios.delete(`${BASEURL}gallery?gallery_name=${name}`);
    },
    onSuccess: () => {
      Swal.fire({
        title: "Deleted Successfully",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button",
        },
      });
      queryClient.invalidateQueries({ queryKey: "getAllimagegalleries" });
    },
  });

  const columns = useMemo(
    () => [
      {
        accessorFn: (row, index) => index + 1,
        id: "index",
        header: "S.No",
        size: 100,
      },

      {
        accessorKey: "gallery_name",
        header: "Title",
      },
      {
        id: "image_url",
        header: "Image",
        size: 500,
        Cell: ({ row }) => (
          <div className="flex ">
            {row?.original?.image_url?.map((v, i) => {
              return (
                <img
                  src={v?.image_url}
                  alt="img"
                  width={50}
                  height={50}
                  className="object-cover mx-2"
                  key={i}
                />
              );
            })}
          </div>
        ),
      },

      {
        id: "actions",
        header: "Actions",
        Cell: ({ row }) => (
          <>
            <div className="flex items-center justify-around">
              <PencilIcon
                onClick={() => handleNavigate(row?.original?.id, row?.original)}
                className="w-5 h-5 cursor-pointer mx-2"
              />

              <TrashIcon
                onClick={() => handleDelte(row?.original?.gallery_name)}
                className="w-5 h-5 cursor-pointer mx-2"
              />
              <LuGalleryVerticalEnd
                onClick={() => handleViewAll(row?.original?.image_url)}
                className="w-5 h-5 cursor-pointer mx-2"
              />
            </div>
          </>
        ),
      },
    ],
    []
  );

  const handleViewAll = (images) => {
    let updatedImages = [...images]; // Copy of images array

    const renderGallery = () => {
      return `
        <div style="display: flex; flex-wrap: wrap; gap: 10px; justify-content: center;">
          ${updatedImages
            .map(
              (img) => `
              <div style="position: relative; display: inline-block;">
                <img 
                  src="${img?.image_url}" 
                  alt="Gallery Image" 
                  class="gallery-img" 
                  data-id="${img?.id}"
                  style="width: 80px; height: 80px; object-fit: cover; cursor: pointer; border-radius: 5px;"
                />
                <button 
                  class="delete-btn" 
                  data-id="${img?.id}"
                  style="
                    position: absolute;
                    top: -5px;
                    right: -5px;
                    background: red;
                    color: white;
                    border: none;
                    border-radius: 50%;
                    width: 20px;
                    height: 20px;
                    cursor: pointer;
                    font-size: 12px;
                  "
                >🗑️</button>
              </div>
            `
            )
            .join("")}
        </div>
      `;
    };

    Swal.fire({
      title: "Gallery",
      html: renderGallery(),
      showCloseButton: true,
      showConfirmButton: false,
      didOpen: () => {
        const modal = Swal.getHtmlContainer();

        // Add delete event listeners
        modal.querySelectorAll(".delete-btn").forEach((btn) => {
          btn.addEventListener("click", (e) => {
            const imageId = e.target.getAttribute("data-id");
            handleDeleteImage(imageId);
          });
        });
      },
    });
  };

  const handleDeleteImage = (id) => {
    deltemutaion.mutate(id);
  };
  const handleNavigate = (id, value) => {
    navigate(`edit`, { state: { id: id, value: value } });
  };

  const handleDelte = (row) => {
    console.log(row, "row");

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        allDeltemutaion.mutate(row);
      }
    });
  };

  return (
    <div>
      {(deltemutaion?.isLoading || allDeltemutaion?.isLoading) && (
        <TraingleLoading />
      )}
      <AdminTabelHeader
        title={"Image Gallery"}
        btnStatus={true}
        path="add"
        btnname="Add"
      />
      <MaterialReactTable
        columns={columns}
        data={data || []}
        enableColumnResizing
        enableColumnOrdering
      />
    </div>
  );
};

export default AdminImageGallery;
